import { HttpClient } from '@angular/common/http';
import { Injectable, NgModule } from '@angular/core';
import { Translation, TranslocoLoader, TranslocoModule, provideTransloco } from '@jsverse/transloco';

import { provideTranslocoPersistLang } from '@jsverse/transloco-persist-lang';

export type TranslocoLanguage = 'it' | 'pl' | 'en';
export const TRANSLOCO_AVAILABLE_LANGS: TranslocoLanguage[] = ['it', 'pl', 'en'];

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  constructor(private http: HttpClient) {}

  getTranslation(lang: string) {
    return this.http.get<Translation>(`/assets/i18n/${lang}.json`);
  }
}

@NgModule({
  imports: [],
  exports: [TranslocoModule],
  providers: [
    provideTransloco({
      config: {
        availableLangs: TRANSLOCO_AVAILABLE_LANGS,
        reRenderOnLangChange: true,
        prodMode: true,
      },
      loader: TranslocoHttpLoader,
    }),
    provideTranslocoPersistLang({
      storage: {
        useValue: localStorage,
      },
    }),
  ],
})
export class TranslocoRootModule {}
